<script setup lang="ts">
import { onMounted } from 'vue';

import { registerToastHandler } from '@/utils/toast-bus';

// Must run inside <UApp> so useToast() resolves the app's toaster context.
const toast = useToast();

onMounted(() => {
  registerToastHandler((options) => toast.add(options));
});
</script>

<template>
  <span class="hidden" aria-hidden="true"></span>
</template>
